import React, { useState } from 'react';
import contactBanner from '../assets/images/contact-banner.jpg';

const Contact = () => {
  const [formDetails, setFormDetails] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDetails({ ...formDetails, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit logic
    console.log('Form submitted:', formDetails);
    alert('Thank you! We will get back to you shortly.');
    setFormDetails({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", padding: '50px' }}>
      <h1 style={{ textAlign: 'center', color: '#22225f', marginBottom: '40px' }}>Contact Us</h1>

      {/* Contact Banner */}
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <img
          src={contactBanner}
          alt="Contact Us"
          style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
        />
      </div>

      {/* Contact Details and Form */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '30px',
          marginTop: '40px',
        }}
      >
        {/* Contact Details Section */}
        <div style={{ flex: '1', minWidth: '300px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '10px' }}>
          <h3 style={{ color: '#22225f', marginBottom: '20px' }}>Contact Details</h3>
          <p style={{ lineHeight: '1.8' }}>
            If you have any queries regarding consulting or financial services, our support team is available 24/7 to
            assist you.
          </p>
          <h4 style={{ marginTop: '20px', color: '#0073e6', fontWeight: 'bold' }}>Need Help?</h4>
          <p><strong>CALFIN</strong></p>
          <p>Plot No. 92, Road No. 4, Vasanth Nagar Colony, Hyderabad - 500085</p>
          <p>
            <strong>Call us now:</strong> +91 7569523497 <br />
            <strong>Visit Our Office:</strong> Monday - Saturday, 10:00 AM to 7:00 PM
          </p>
        </div>

        {/* Inquiry Form Section */}
        <div style={{ flex: '1', minWidth: '300px', padding: '20px', backgroundColor: '#fff', borderRadius: '10px' }}>
          <h3 style={{ color: '#22225f', marginBottom: '20px' }}>Send Message Us</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                name="name"
                value={formDetails.name}
                onChange={handleChange}
                placeholder="Name*"
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  fontSize: '16px',
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <input
                type="email"
                name="email"
                value={formDetails.email}
                onChange={handleChange}
                placeholder="Email*"
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  fontSize: '16px',
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                name="subject"
                value={formDetails.subject}
                onChange={handleChange}
                placeholder="Subject"
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  fontSize: '16px',
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <textarea
                name="message"
                value={formDetails.message}
                onChange={handleChange}
                placeholder="Message..."
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  fontSize: '16px',
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  minHeight: '100px',
                }}
              />
            </div>
            <button
              type="submit"
              style={{
                display: 'block',
                width: '100%',
                padding: '12px',
                backgroundColor: '#0073e6',
                color: '#fff',
                fontSize: '18px',
                fontWeight: 'bold',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              }}
            >
              Send Now
            </button>
          </form>
        </div>
      </div>

      {/* Floating WhatsApp Chat Button */}
      <a
        href="https://wa.me/917569523497?text=Hello!%20I%20have%20a%20query%20regarding%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25d366',
          borderRadius: '50%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: '40px', height: '40px' }}
        />
      </a>
    </div>
  );
};

export default Contact;
